/*
 * O contrato entre os modelos 3D e o viewer do CMA.
 *
 * Existem dois modelos hoje — transformadorProcedural.js, construído em
 * código, e transformadorCad.js, carregado de um GLB — e o viewer
 * (CmaAsset3dView.vue) trata os dois sem saber de onde vieram. É este arquivo
 * que descreve o que os dois têm de devolver, e guarda as convenções que
 * atravessam essa fronteira.
 *
 * FORMATO DO MODELO
 *
 *   {
 *     id,          // string — id do slot no carrossel (ver TRANSFORMER_MODELS)
 *     group,       // THREE.Group — a raiz do modelo, entra no slot do anel
 *     parts,       // { [nome]: THREE.Group } com userData.home e .explode,
 *                  //   percorrido por applyExplosion a cada quadro
 *     anchors,     // [{ id, part, point }] — `id` é o do CARD (ver
 *                  //   CONNECTOR_DEFS em CmaDashboard.vue), não o da peça;
 *                  //   é o que liga enquadramento, highlight e linhas de
 *                  //   conexão a uma peça deste modelo
 *     helices,     // objetos com userData.giro    — updateFans
 *     ponteiros,   // objetos com userData.repouso — updateGauges
 *     raios,       // objetos com userData.percurso — updateCurrent
 *   }
 *
 * As cinco coleções podem vir VAZIAS, e isso é parte do contrato: cada recurso
 * do viewer percorre a sua e simplesmente não age sobre o modelo quando ela
 * está vazia, em vez de quebrar. É o que permite um modelo entrar na cena antes
 * de ter peças nomeadas — como o do CAD, que hoje chega como malha única.
 *
 * O `group` tem de existir de forma SÍNCRONA, mesmo que o conteúdo chegue
 * depois: o viewer monta o carrossel e seleciona o modelo por índice/id antes
 * de qualquer download, e um slot a menos deslocaria o anel inteiro.
 */

/**
 * Nome da malha que representa a peça no highlight.
 *
 * Um builder pode marcar UMA malha com este nome para dizer "é esta que
 * recebe o realce", em vez de tingir a peça inteira — o tanque, por exemplo,
 * marca o corpo e deixa flanges e tubos de fora. Sem nenhuma malha marcada, o
 * viewer tinge a peça toda (ver highlightPart).
 */
export const HIGHLIGHT_TARGET = 'highlight';

export default HIGHLIGHT_TARGET;
